
import React, { useState } from "react";
import { useSelector } from "react-redux";

const Player = ({ player, toggle, selectedAudio, handleSelectAudio, stopAudio, setPageloader }) => {

  const [playersIcon, setPlayersIcon] = useState(true);
  const handleSelect = async (e, url) => {
    e.preventDefault();
    setPageloader(true);
    handleSelectAudio(url);
    stopAudio();
    setPlayersIcon(false)
    await delay(1000);
    setPageloader(false);
    // console.log(playersIcon);
    // console.log(player);
  };

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const handleToggle = (e) => {
    e.preventDefault();
    toggle();
    setPlayersIcon(true)

  };

  const subdomain_name = useSelector((state) => state.auth.product.subdomain_name);

  console.log("Calling");
  return (
    <div className="col-sm-6">
      <div className="audio_bx mb-4">
        <h6 className="text-capitalize text-dark">{player.name}</h6>
        <div className="audio_rw">
          <div className="audio_range">
            <img
              src={
                (player.playing && playersIcon)
                  ? process.env.PUBLIC_URL +
                    "/assets/images/audio_range_selected.png"
                  : process.env.PUBLIC_URL + "/assets/images/audio_range.png"
              }
              className="img-fluid"
              alt="img"
            />
          </div>
          <div className="pause_play">
            <a href="#0" onClick={(e) => handleToggle(e)}>
              <img
                src={
                  (player.playing && playersIcon)
                    ? process.env.PUBLIC_URL + "/assets/images/pause.png"
                    : process.env.PUBLIC_URL + "/assets/images/play2.png"
                }
                alt="img"
                data-toggle="tooltip"
                data-placement="top"
                data-bs-original-title={(player.playing && playersIcon) ? "Pause" : "Play"}
              />
            </a>
          </div>
          <div className="add_audio">
            <a
              href="#0"
              data-toggle="tooltip"
              data-placement="top"
              title="Select Audio"
              onClick={(e) => handleSelect(e, player.url)}
            >
            {
              (subdomain_name === "vidwise") ? (
                <img
                    src={
                      selectedAudio === player.url
                        ? process.env.PUBLIC_URL + "/assets/images/check11.png"
                        : process.env.PUBLIC_URL + "/assets/images/add11.png"
                    }
                    alt="img"
                  />
              ):(
                <img
                    src={
                      selectedAudio === player.url
                        ? process.env.PUBLIC_URL + "/assets/images/check.png"
                        : process.env.PUBLIC_URL + "/assets/images/add.png"
                    }
                    alt="img"
                  />
              )
            }
              
            </a>
          </div>
        </div>
        {/* <button onClick={toggle}>{player.playing ? "Pause" : "Play"}</button> */}
      </div>
    </div>
  );
};

export default Player;
